'use client';

import dynamic from 'next/dynamic';
import { SampleOrderSuspenseFallback } from '../SampleOrderSuspenseFallback/SampleOrderSuspenseFallback';

export const LazySampleOrder = dynamic(
  () =>
    import(/* webpackChunkName: 'SampleOrder' */ '../../SampleOrder/SampleOrder.client').then(
      (module) => ({
        default: module.SampleOrder,
      }),
    ),
  { ssr: false, loading: () => <SampleOrderSuspenseFallback /> },
);
